import { clsx } from '../../utils/cn.js';

export default function Button({
  children,
  variant = 'primary',
  className,
  disabled,
  type = 'button',
  ...props
}) {
  const base =
    'inline-flex items-center justify-center gap-2 rounded-lg px-5 py-2.5 text-sm font-semibold transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-50 disabled:pointer-events-none';

  const cta =
    'border border-transparent bg-black text-white shadow-sm hover:bg-neutral-900 hover:text-white focus-visible:outline-neutral-400';

  const variants = {
    primary: cta,
    outline:
      'border border-white/25 bg-slate-900/50 text-slate-100 shadow-sm hover:border-white/35 hover:bg-black hover:text-white focus-visible:outline-neutral-400',
    /** Panel admin y superficies claras */
    outlineLight:
      'border border-slate-300 bg-white text-slate-700 shadow-sm hover:border-slate-400 hover:bg-slate-50 hover:text-slate-900 focus-visible:outline-[#0d2b7f]/40',
    ghost: 'bg-transparent text-white/85 hover:bg-white/10 hover:text-white focus-visible:outline-white/30',
    danger:
      'bg-red-800 text-white hover:bg-red-700 focus-visible:outline-red-500',
    outlineInverse: clsx(cta, 'shadow-md'),
  };

  return (
    <button
      type={type}
      disabled={disabled}
      className={clsx(base, variants[variant] ?? variants.primary, className)}
      {...props}
    >
      {children}
    </button>
  );
}
